const Svg = ({ name, ...rest }) => {
  let importedSvg = require('./source/' + name);

  let CurrentSvg = importedSvg.default;

  return <CurrentSvg {...rest} />;
};

export default Svg;
